import { render } from "./harvesterhci.io.dashboard.vue?vue&type=template&id=70453033&scoped=true"
import script from "./harvesterhci.io.dashboard.vue?vue&type=script&lang=js"
export * from "./harvesterhci.io.dashboard.vue?vue&type=script&lang=js"

import "./harvesterhci.io.dashboard.vue?vue&type=style&index=0&id=70453033&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70453033"]])

export default __exports__